export * from "ce/pages/common/PackageSearchItem";
import { default as CE_PackageSearchItem } from "ce/pages/common/PackageSearchItem";
export default CE_PackageSearchItem;
